import {RouteRecordRaw} from "vue-router";
import LayoutView from "@/views/share/LayoutView.vue";
import EditorHeader from "@/views/editor/EditorHeader.vue";
import EditorSide from "@/views/editor/EditorSide.vue";
import {session} from "@/model/session";
import {message} from "ant-design-vue";
import {api} from "@/lib/api";
import {IActivityMetadata} from "@/model/activity";
import {UserAgent} from "@/model/user_agent";

const editors: { [key: string]: () => Promise<any> } = {
    'a-promotion_tiergroup-price': () => import(/* webpackChunkName: "promotion_tier_group_price" */ './promotion_tier_group_price'),
    'a-promotion_tiergroup': () => import(/* webpackChunkName: "promotion_tier_group" */ './promotion_tier_group'),
    'a-promotion_tiergroup-alliance': () => import(/* webpackChunkName: "promotion_tier_group_alliance" */ './promotion_tier_group_alliance'),
}

const primaryTag = (tags: string[]): string => {
    for (let i = tags.length - 1; i >= 0; i--) {
        if (tags[i].startsWith("a-")) return tags[i];
    }
    throw new Error('模板标签异常');
}

export default <Array<RouteRecordRaw>>[
    {
        path: '/editor',
        meta: {auth: true},
        component: LayoutView,
        children: [
            {
                path: '',
                meta: {auth: true},
                beforeEnter: async (to, from, next) => {
                    to.meta.material = await session.material()
                    if (to.query.activity_id) next();
                    else if (to.query.tags) {
                        try {
                            const done = message.loading('加载中', 0)
                            const am = await api<void, IActivityMetadata>(
                                {url: 'user/activity', method: 'POST', data: to.query}
                            ).finally(done)
                            // console.log('am:', am, primaryTag(to.query.tags as string[]))
                            if (!editors[primaryTag(to.query.tags as string[])]) throw new Error('编辑器暂不支持此类型')
                            const m = await editors[primaryTag(to.query.tags as string[])]()
                            to.meta.editor = new m.Editor(to.meta.agent as UserAgent,am, to.meta.material)
                            return next()
                        } catch (error) {
                            console.log(error)
                            if (error instanceof Error) message.error(error.message)
                            return next('/');
                        }
                    } else return next('/');
                },
                components: {
                    default: () => import(/* webpackChunkName: "editor" */ './EditorPage.vue'),
                    header: EditorHeader,
                    side: EditorSide,
                },
            },
        ]
    }
]

